module.exports = __webpack_public_path__ + "img/006.0abe546f.png";